<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item>
                <router-link to="/EodbReport">
                  EODB Report
                </router-link>
              </b-breadcrumb-item>
                 <b-breadcrumb-item href="#" active>ePanjeeyan Mutation Report</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">ePanjeeyan Mutation Report</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
           <br>
           <b-row style="padding-left: 1rem;;">
            <!-- <b-col cols="4">
              <b-row>Total ePanjeeyan Data Received : <div id="" style="padding-left: 1rem;font-weight: 600;
  color: #3210f1  ;">2</div></b-row>
            </b-col> -->
            <b-col cols="4">
              <b-row>Total Applications Received : <div id="tot_appl" style="padding-left: 1rem;font-weight: 600;
  color: #dd2c00  ;">0</div></b-row>
            </b-col>
            <b-col cols="4">
              <b-row>Total Completed Mutation : <div id="tot_mutation" style="padding-left: 1rem;font-weight: 600;
  color: #068220  ;">0</div></b-row>
            </b-col>
           </b-row>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->

      <div id="ConsDetails" class="" style="width:90vw;font-size:0.8rem;">
          <br>
          <b-table bordered responsive :items="report" :fields="reportFields">
            
          </b-table>
      </div>
      <b-row><b-col><div id="showTable" style="text-align: center;color:rgb(148, 37, 37);"></div></b-col></b-row>
      <br>
      <b-row>
          <b-col cols="12" lg="6">
            <span style="color:grey; ">
            * Dashboard Data updated on daily basis.
          </span>
          </b-col>
      </b-row>
      </div>
  </b-container>

<br><br>
</b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var consNo="";
var sdCode="";
var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },

  data() {
    return {

      reportFields: [
        { key: 'sl_no', label: 'Sl. No.',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'cons_no', label: 'Consumer No.',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'appl_no', label: 'Applications No.',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'new_name', label: 'New Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'status', label: 'Status',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'appl_date', label: 'Applied Date',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'comp_date', label: 'Completion Date',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'tot_time', label: 'Total Time of Completion (in days)',thStyle: {width: '40vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            ],
      report : [],

      show:false,
      curFinYear :""

    }
  },
  methods:
  {
    maskName(name) {
      if (!name || name.length <= 4) return name; // too short to mask meaningfully
      const first = name.slice(0, 2);
      const last = name.slice(-2);
      const middleLength = name.length - 4;
      return first + '*'.repeat(middleLength) + last;
    }
  },
  mounted() {
    var temp = [];
    var obj, sl=1;
    var application_date, completion_date;
    var statusCheck = "Change Submission Successfully Processed & Closed";
    var success=1;
    var parent = this;
    axios.get(this.$urlCommon+ "/api/web/ePanjeeyanReport")
    .then((response) => {
      parent.show= false;
      // document.getElementById("showTable").style.display="none;"
      // console.log(response.data.ePanjeeyanReport);
      // return;

      var data = response.data.ePanjeeyanReport;
      console.log("data length: ", data.length);

      if(data.length == 0){
        document.getElementById("showTable").innerHTML="No Data Available";
      }
      else{
        data.forEach(element =>{
        
        application_date = element.applied_dt;
        application_date = application_date.split("T");
        application_date = application_date[0].split("-");
        application_date = application_date[2]+"/"+application_date[1]+"/"+application_date[0];

        completion_date = element.release_dt;
        completion_date = completion_date.split("T");
        completion_date = completion_date[0].split("-");
        completion_date = completion_date[2]+"/"+completion_date[1]+"/"+completion_date[0];

        if(statusCheck == element.status){
          success = success+1;
        }

        obj = {
          "sl_no" : sl,
          "cons_no" :  element.cons_no,
          "appl_no" :  element.appl_no,
          "new_name" :  parent.maskName(element.applied_name),
          "status" :  element.status,
          "appl_date" :  application_date,
          "comp_date" :  completion_date,
          "tot_time" : element.total_time_taken
          }
          sl=sl+1;
          temp.push(obj);
        parent.report = temp;
      });
      document.getElementById("tot_appl").innerHTML=sl-1;
      document.getElementById("tot_mutation").innerHTML=success-1;
      }
      
      
    })

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

/deep/ .table > tbody > tr > td {
  /* font-size: 1rem; */
  text-align: center;
  /* font-weight: 600;
  color: #dd2c00  ; */
}
/deep/ .table > thead > tr > th {
  /* font-size: 1rem; */
  text-align: center;
  /* font-weight: 600;
  color: #dd2c00  ; */
}
.title {
  color: #1976d2;
  font-size: 1.5rem;
  font-weight: 600;
  text-transform: none !important;
}
.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.2rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
